import axios from 'axios';
import config from '../config';
import {handlingSession,sessionID} from './../../utils/handlingSession'
import {userLogs} from './../logs/userLogs'
import {getSessionIdFromStorage} from '../../utils/helpers/storageUtils'


let sessionId = getSessionIdFromStorage();

const headers = {
    'session_id': sessionId,
  }

export const avatar = async (formData) => {
    let url = config.hummBackendAppURL+'user/userimage';

   return axios.post(url, formData ,{headers:sessionID('secured')}).then(res => {
        return res;
    })
    .catch(async err => {
        await userLogs(url,formData,err);
        if(err.response){
        handlingSession(err.response.status);
        }
        return err.response
    })


};